import { Link } from "react-router-dom";
import { SITE_EMAIL } from "@/utils/format";

export default function SubmitCta() {
  return (
    <section className="relative w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20illustration%20of%20a%20megaphone%20surrounded%20by%20floating%20speech%20bubbles%20and%20geometric%20spark%20shapes%2C%20deep%20terracotta%20and%20amber%20color%20gradient%2C%20cinematic%20soft%20lighting%2C%20no%20text%2C%20no%20faces&width=1600&height=640&seq=guayouhui-cta-band&orientation=landscape"
        alt="瓜友会网爆料投稿通道背景图"
        title="瓜友会网 · 爆料投稿"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/85 via-primary-900/70 to-accent-950/60"></div>
      <div className="relative z-10 w-full px-4 md:px-8 py-14 md:py-20 text-center flex flex-col items-center">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/25 text-background-50 text-xs md:text-sm">
          <i className="ri-megaphone-line" aria-hidden="true"></i>
          爆料投稿通道
        </span>
        <h2 className="mt-5 text-2xl md:text-4xl font-bold text-background-50 tracking-tight">
          手里有瓜？投给我们
        </h2>
        <p className="mt-4 max-w-2xl text-sm md:text-base text-background-100/85 leading-relaxed">
          附上大致时间和可公开求证的信息来源，我们会先核实再整理成清晰的时间线。
          投稿可不留真实姓名，除邮箱外不收集任何身份信息。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
          <Link
            to="/about#submit"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 h-12 px-7 rounded-full bg-accent-500 text-foreground-950 text-sm md:text-base whitespace-nowrap hover:bg-accent-400 transition-colors cursor-pointer"
          >
            <i className="ri-send-plane-line text-lg" aria-hidden="true"></i>
            填写投稿表单
          </Link>
          <a
            href={`mailto:${SITE_EMAIL}`}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 h-12 px-7 rounded-full bg-background-50/10 border border-background-50/30 text-background-50 text-sm md:text-base whitespace-nowrap hover:bg-background-50/20 transition-colors cursor-pointer"
          >
            <i className="ri-mail-line text-lg" aria-hidden="true"></i>
            {SITE_EMAIL}
          </a>
        </div>
      </div>
    </section>
  );
}